import React from "react";
import { Jourpage } from "../Components/Jourpage";

function DesignJourney(props) {
  return (
    <>
      <Jourpage props={props} />
    </>
  );
}

export default DesignJourney;
